import React from "react";
import { Bubble, HorizontalBarChart, Kpi } from "./charts";

export const BrandsBenchmark = () => (
  <svg viewBox="0 0 108 136">
    <Kpi x={8} y={8} />
    <Kpi x={40} y={8} />
    <Kpi x={72} y={8} />

    <Bubble x={8} y={28} />

    <HorizontalBarChart x={8} y={82} />
    <HorizontalBarChart x={40} y={82} />
    <HorizontalBarChart x={72} y={82} />

    <HorizontalBarChart x={8} y={114} />
    <HorizontalBarChart x={40} y={114} />
    <HorizontalBarChart x={72} y={114} />
  </svg>
);
